import * as types from './actionTypes';

export const success = (content, duration = 5000, onClose) => {
  return (dispatch, getState) => {
    showMessage({
      dispatch,
      getState,
      content,
      duration,
      onClose,
      category: 'success',
    });
  };
};

export const warning = (content, duration = 5000, onClose) => {
  return (dispatch, getState) => {
    showMessage({
      dispatch,
      getState,
      content,
      duration,
      onClose,
      category: 'warning',
    });
  };
};

export const error = (content, duration = 5000, onClose) => {
  return (dispatch, getState) => {
    showMessage({
      dispatch,
      getState,
      content,
      duration,
      onClose,
      category: 'error',
    });
  };
};

export const info = (content, duration = 5000, onClose) => {
  return (dispatch, getState) => {
    showMessage({
      dispatch,
      getState,
      content,
      duration,
      onClose,
      category: 'info',
    });
  };
};

const showMessage = (params) => {
  const { dispatch, getState, content, duration, onClose, category } = params;

  let { timeoutId } = getState().messageReducer;

  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  timeoutId = setTimeout(() => {
    dispatch({
      type: types.HIDE_MESSAGE,
    });
    onClose && onClose();
  }, duration);

  dispatch({
    type: types.SHOW_MESSAGE,
    payload: {
      content,
      duration,
      onClose,
      category,
      timeoutId,
    },
  });
};
